import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getFloodRiskReport,
  getPartner,
  getPlateStateReport,
  getRecallReport,
  getRecallSummary,
  getViewFullReport,
  getVinReport,
  getZipcode,
} from "../../service/reports";

const initialState = {
  reportSummary: [],
  partners: [],
  zipCodes: [],
  viewFullReport: [],
  vinRepo: [],
  plateStateRepo: [],
  floodRepo: {},
  recallReport: [],
  error: "",
};

export const fetchReports = createAsyncThunk(
  "fetchReports/fetchReports",
  async (action) => {
    let response;
    switch (action.condition) {
      case "getRecallSummary":
        response = await getRecallSummary(action.payload);
        return response;
      case "getPartner":
        response = await getPartner(action.payload);
        return response;
      case "getZipcode":
        response = await getZipcode(action.payload);
        return response;
      case "getFullReport":
        response = await getViewFullReport(action.payload);
        return response;
      case "getVinReport":
        response = await getVinReport(action.payload);
        return response;
      case "getPlateStateReport":
        response = await getPlateStateReport(action.payload);
        return response;
      case "getFloodRiskReport":
        response = await getFloodRiskReport(action.payload);
        return response;
      case "getRecallReport":
        response = await getRecallReport(action.payload);
        return response;
      default:
        throw new Error("Invalid condition");
    }
  }
);

export const reportSlice = createSlice({
  name: "fetchReports",
  initialState,
  reducers: {
    clearData: (state) => {
      state.error = "";
      state.success = "";
    },
    resetVinRepo(state) {
      state.vinRepo = [];
      state.plateStateRepo = [];
      state.floodRepo = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReports.fulfilled, (state, action) => {
        state.status = "succeeded";
        switch (action.payload.API_Name) {
          case "getRecallSummary":
            state.reportSummary = action.payload.response.data.data;
            break;
          case "getPartner":
            state.partners = action.payload.response.data;
            break;
          case "getZipcode":
            state.zipCodes = action.payload.response.data.data;
            break;
          case "getVinReport":
            state.vinRepo = action.payload.response.data;
            localStorage.setItem(
              "vhr.vehicle",
              JSON.stringify(action.payload.response.data)
            );
            localStorage.setItem("vhr.showSummary", true);
            break;
          case "getPlateStateReport":
            state.plateStateRepo = action.payload.response.data;
            localStorage.setItem(
              "vhr.vehicle",
              JSON.stringify(action.payload.response.data)
            );
            localStorage.setItem("vhr.showSummary", true);
            break;
          case "getFloodRiskReport":
            state.floodRepo = action.payload.response.data;
          case "getViewFullReport":
            state.viewFullReport = action.payload.response.data;
            break;
          case "getRecallReport":
            state.recallReport = action.payload.response.data;
            break;

          default:
            break;
        }
      })
      .addCase(fetchReports.pending, (state, action) => {
        state.status = "loading";
        if (action.meta.arg && action.meta.arg.condition === "getFullReport") {
          state.viewFullReport = [];
        }
      })
      .addCase(fetchReports.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        if (action.meta.arg.condition === "getFullReport") {
          state.viewFullReport = [];
        }
      });
  },
});

export const { clearData, resetVinRepo } = reportSlice.actions;

export default reportSlice.reducer;
